var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendingUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 12L27 31L17 21L2 36",
    stroke: "url(#paint0_linear_185_304)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 12H46V24",
    stroke: "url(#paint1_linear_185_304)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_304",
    x1: 2,
    y1: 25.4118,
    x2: 45.9799,
    y2: 26.3513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0239582,
    stopColor: "#ED3237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F08F21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_185_304",
    x1: 34,
    y1: 18.7059,
    x2: 45.9984,
    y2: 18.8457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0239582,
    stopColor: "#ED3237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F08F21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp);
export default __webpack_public_path__ + "static/media/trending-up.c35ca77766d8369b15efb22906747815.svg";
export { ForwardRef as ReactComponent };